import { IStoreInfo } from "../interfaces/PaymentSuccessHelper";
import { STORE_TYPE } from "../constants/EventBooking";

export const isEventOrganisedByRX = (storeInfo: IStoreInfo) => {
    return storeInfo.type === STORE_TYPE.RX;
};
